/**
 * program
 * Program APIs
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ProgramEligibilityDataDto } from './programEligibilityDataDto';


export interface ProgramEligibilityDto { 
    /**
     * The patient identifier.
     */
    patientId: string;
    /**
     * The value indicating if the patient is eligible for the program.
     */
    isEligible: boolean;
    /**
     * The value indicating if the patient has an active program.
     */
    isEnrolled: boolean;
    /**
     * The program identifier. The program identifier exists if program is in active or pending status.
     */
    programId?: string;
    /**
     * The program hub status. The program hub is program representation on the home page.
     */
    programHubStatus: ProgramEligibilityDto.ProgramHubStatusEnum;
    /**
     * The program eligibility data providing more details for program hub.
     */
    data?: ProgramEligibilityDataDto;
}
export namespace ProgramEligibilityDto {
    export type ProgramHubStatusEnum = 'not-enrolled' | 'intake-in-progress' | 'intake-completed' | 'offer-pending' | 'active';
    export const ProgramHubStatusEnum = {
        NotEnrolled: 'not-enrolled' as ProgramHubStatusEnum,
        IntakeInProgress: 'intake-in-progress' as ProgramHubStatusEnum,
        IntakeCompleted: 'intake-completed' as ProgramHubStatusEnum,
        OfferPending: 'offer-pending' as ProgramHubStatusEnum,
        Active: 'active' as ProgramHubStatusEnum
    };
}


